// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__uAb5r","overflowing":"ReadFullNote_overflowing__3IC7f"};